function normalizeEnumValue(value, allowedValues, fallbackValue) {
  return allowedValues.includes(value) ? value : fallbackValue
}

export const CALL_PHASES = Object.freeze({
  idle: 'idle',
  joining: 'joining',
  joined: 'joined',
  reconnecting: 'reconnecting',
  left: 'left',
  failed: 'failed',
})

/**
 * @param {string | null | undefined} callPhase
 * @param {string} [fallbackValue=CALL_PHASES.idle]
 * @returns {string}
 */
export function normalizeCallPhase(callPhase, fallbackValue = CALL_PHASES.idle) {
  return normalizeEnumValue(callPhase, Object.values(CALL_PHASES), fallbackValue)
}
